/**
 * track name
 */
export const TRACK_NAME = {
  page_view: 'page_view',
  page_stay_duration: 'page_stay_duration',
  move: 'move',
  click: 'click',
  upload: 'upload',
  user_paid: 'user_paid',
  impression: 'impression',
  scroll_25: 'scroll_25',
  scroll_50: 'scroll_50',
  scroll_75: 'scroll_75',
  session_start: 'session_start',
  first_visit: 'first_visit',
  web_error: 'web_error',
  user_registered: 'user_registered',
  evaluation_exit_survey_submit: 'evaluation_exit_survey_submit',
  baidu_track: '_trackPageview',
};

/**
 * event group or id
 */
export const DATA_ELE_ID = 'data-ele-id';
export const DATA_ELE_GROUP = 'data-ele-group';
export const RESUME_MANAGEMENT_RESUME_TBS_GROUP = 'tabs_简历管理';

export const RESUME_MANAGEMENT_EVALUATION_TBS_GROUP = 'tabs_诊断报告';

export const RESUME_EVALUATION_GROUP = 'evaluation_简历诊断';

export const RESUME_EVALUATION_PAID_LANDING_ID = 'landing_付费引导页';

export const RESUME_EVALUATION_FULL_REPORT_ID = 'report_完整报告页';

/**
 * cookie name
 */
export const USER_ID_COOKIE_NAME = 'user_id';
export const _BI_COOKIE_NAME = '_bi';
export const CID_COOKIE_NAME = 'cid';
export const SID_COOKIE_NAME = 'sid';
export const HAS_SEEN_NEW_LABEL_COOKIE_NAME = 'hasSeenNewLabel=true';

/**
 * storage name
 */
export const SESSION_START_STORAGE_NAME = 'session_start';
export const REFERRER_STORAGE_NAME = 'referer';
export const BEFORE_LOGIN_REFERRER_STORAGE_NAME = 'before_login_referer';
